import { render, staticRenderFns } from "./PersonalizedGameEditorColor.vue?vue&type=template&id=6d6e8d82&scoped=true&"
import script from "./PersonalizedGameEditorColor.vue?vue&type=script&lang=js&"
export * from "./PersonalizedGameEditorColor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d6e8d82",
  null
  
)

export default component.exports